import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  // mode:'history',
  routes: [{
      path: '/',
      name: 'index',
      component: () => import('@/views/index/index')
    },
    {
      path: '/article/show',
      name: 'articleshow',
      component: () => import('@/views/article/show')
    },
    {
      path: '/article/index',
      name: 'policy',
      component: () => import('@/views/article/index')
    },
    {
      path: '/article/index1',
      name: 'serviceindex',
      component: () => import('@/views/article/index1')
    },
    {
      path: '/article/index2',
      name: 'agency',
      component: () => import('@/views/article/index2')
    },
    {
      path: '/article/index3',
      name: 'zixun',
      component: () => import('@/views/article/index3')
    },
    // {
    //   path: '/article/index',
    //   name: 'serviceindex',
    //   component: () => import('@/views/article/index')
    // },
    // {
    //   path: '/article/index',
    //   name: 'agency',
    //   component: () => import('@/views/article/index')
    // },
    // {
    //   path: '/article/index',
    //   name: 'zixun',
    //   component: () => import('@/views/article/index')
    // },
    {
      path: '/contactus/index',
      name: 'contactus',
      component: () => import('@/views/contactus/index')
    },
    {
      path: '/serviceEvaluation/index',
      name: 'serviceEvaluation',
      component: () => import('@/views/serviceEvaluation/index')
    },
    {
      path: '/sacrifice/login',
      name: 'sacrificelogin',
      component: () => import('@/views/sacrifice/login')
    },
    {
      path: '/sacrifice/index',
      name: 'sacrificeindex',
      component: () => import('@/views/sacrifice/index')
    },
    {
      path: '/sacrifice/show/:id',
      name: 'sacrificeshow',
      component: () => import('@/views/sacrifice/show')
    },
    {
      path: '/sacrifice/showItem/:id',
      name: 'sacrificeShowItem',
      component: () => import('@/views/sacrifice/showItem')
    },
    {
      path: '/sacrifice/showDw/:id',
      name: 'sacrificeShowDw',
      component: () => import('@/views/sacrifice/showDw')
    },
    {
      path: '/sacrifice/showLy/:id',
      name: 'sacrificeShowLy',
      component: () => import('@/views/sacrifice/showLy')
    },
    {
      path: '/sacrifice/showJdjl/:id',
      name: 'sacrificeShowJdjl',
      component: () => import('@/views/sacrifice/showJdjl')
    },
    // {
    //   path: '/agency/show',
    //   name: 'agencyshow',
    //   component: () => import('@/views/agency/show')
    // },
    // {
    //   path: '/notice',
    //   name: 'notice',
    //   component: () => import('@/views/notice')
    // },
    // {
    //   path: '/basic/step0',
    //   name: 'basicstep0',
    //   component: () => import('@/views/basic/step0')
    // },
    // {
    //   path: '/basic/step1',
    //   name: 'basicstep1',
    //   component: () => import('@/views/basic/step1')
    // },
    // {
    //   path: '/basic/step2',
    //   name: 'basicstep2',
    //   component: () => import('@/views/basic/step2')
    // },
    // {
    //   path: '/basic/success',
    //   name: 'basicsuccess',
    //   component: () => import('@/views/basic/success')
    // },
    // {
    //   path: '/business/step0',
    //   name: 'businesstep0',
    //   component: () => import('@/views/business/step0')
    // },
    // {
    //   path: '/business/step1',
    //   name: 'businesstep1',
    //   component: () => import('@/views/business/step1')
    // },
    // {
    //   path: '/business/success',
    //   name: 'businessuccess',
    //   component: () => import('@/views/business/success')
    // },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js